import * as React from "react";
import { Stack, Card, CardContent, Typography } from "@mui/material";

interface InventoryRecord {
  airbagsCount: number;
  fullBinsCount: number;
  emptyBinsCount: number;
}

const labels: Record<string, string> = {
  fullBinsCount: "Caisses pleines actuels",
  emptyBinsCount: "Caisses vides actuels",
  airbagsCount: "Nb airbag en vrac actuel",
};

export const SummaryCards: React.FC<{ latest: InventoryRecord }> = ({
  latest,
}) => (
  <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
    {(["fullBinsCount", "emptyBinsCount", "airbagsCount"] as const).map(
      (key) => (
        <Card
          sx={{ flex: 1, textAlign: "center", bgcolor: "background.default" }}
          key={key}
        >
          <CardContent>
            <Typography variant="subtitle2">{labels[key]}</Typography>
            <Typography variant="h6">{latest[key]}</Typography>
          </CardContent>
        </Card>
      )
    )}
  </Stack>
);
